import type { KeyboardEvent, ReactNode } from 'react';

import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';

import { RowLink } from '../ScenarioGrid.style';

type RowLabelActionProps = {
    onActivate: () => void;
    disabled?: boolean;
    expanded?: boolean;
    testId?: string;
    children: ReactNode;
};

export const RowLabelAction = ({ onActivate, disabled = false, expanded, testId, children }: RowLabelActionProps) => {
    const theme = useInterstateTheme();
    const activate = () => {
        if (!disabled) onActivate();
    };

    const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            activate();
        }
    };

    return (
        <RowLink
            theme={theme}
            role="button"
            tabIndex={disabled ? -1 : 0}
            aria-disabled={disabled || undefined}
            aria-expanded={expanded}
            $disabled={disabled}
            onClick={activate}
            onKeyDown={handleKeyDown}
            data-testid={testId}
        >
            {children}
        </RowLink>
    );
};
